import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'filterForMultiselect'
})
export class FilterForMultiselectPipe implements PipeTransform {
  constructor(private translation: TranslateService) { }

  // Use i18n currently loaded translation, since translations cannot be localized
  public currentLang = this.translation.currentLang;

  public transform(items: any, args?: any): any {
    const options = [];
    items.forEach(option => {
        options.push({
            label: option.translations.find(el => el.languageId === this.currentLang)?.value,
            value: option
        });
    });
    return options;
  }

}
